import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=3e6fe18a&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=ts&"
export * from "./detail.vue?vue&type=script&lang=ts&"
import style0 from "../less/detail.less?vue&type=style&index=0&id=3e6fe18a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6fe18a",
  null
  
)

export default component.exports